/*    
<summary>
  This typescript file contains special datatype that enables for a variale to be set of predefined constant.
  This constant is used in providing paths for API Route URL for every modules.
    Developer: Mohammad Saquib Khan, Created Date: 29-March-2025
</summary>
*/

import { IUrlConstant } from "../models/IUrlConstants";

// Controller base paths
const StaffController = `/Staff`;
const StoreController = `/Store`;
const TreatmentController = `/TreatmentRegistration`;
const ProductController = `/ProductRegistration`;
const ShiftController = `/Shift`;
const InventoryManagementController = `/SalesMedicalRecord/InventoryManagement`;
const EmailManagementController = `/EmailManagement`;
const TotallingManagement = `/TotallingManagement`;

// URL constants for API endpoints
const URLConstants: any = {
  // Authentication endpoints
  Authenticate: "/Account/Login",
  RefreshToken: "Account/RefreshToken",
  Logout: "/Account/Logout",
  ActivateAccount: "/Account/Activate",
  ResendLink: "Account/Activate/Resend/Link",
  PasswordResetLink: "Account/User/Email/Verification",
  ResetPassword: "Account/Update/User/Password",
  ChangePassword: "Account/Update/Password",
  AuthorizeAccount: "Account/Authorize",

  // User management
  GetUserById: "/User",
  DeleteUser: "/User",
  UpdateUser: "/User",
  AddUser: "/v1/User/AddUser",
  Version: "/v1/Version",

  // Store management
  Store: "/Store",
  StoreFilter: "/Store/Filter",
  StoreSearchFilter: "/Store/Search/Filter",
  StoreByBusinessTypeId: "/Store/BusinessTypeId",
  StoreCms: "Cms/Store/StoreDetails",
  StoreCmsAnonymous: "Cms/StoreDetails",
  StoreCmsByStoreCodeAnonymous: "Cms/Store/StoreDetails/StoreCode",
  UpdateStoreCms: "Cms/StoreDetails",
  CmsBusinessTypeConditional: "Cms/BuisnessType/Conditional",
  StoreAllPrefectureName: "/Store/PrefectureName/All",

  // Product management
  GetProductManagementList: `${ProductController}/List`,
  GetProductManagementFilter: `${ProductController}/Filter`,
  GetSearchProductRegistrationFilter: `${ProductController}/Search/Filter`,
  AddProduct: `${ProductController}`,
  UpdateProduct: `${ProductController}`,
  GetProductById: `${ProductController}`,
  DeleteProduct: `${ProductController}`,
  GetProductRegistartionStoreId: `${ProductController}/StoreId`,
  UpdateStoreProductOrderId: `${ProductController}/OrderId`,
  GetProductRegistartionStoreIdWithBarcode: `${ProductController}/StoreId/BarCode`,

  // Master and Payment management
  MasterManagement: "/MasterManagement",
  PaymentManagement: "/PaymentManagement",
  MiscellaneousSetting: "/MasterManagement/MiscellaneousSetting",

  // Category management
  CategoryManagementList: "/CategoryRegistration/List",
  AddCategoryManagement: "CategoryRegistration",
  UpdateCategoryManagement: "CategoryRegistration",
  GetCategoryById: "CategoryRegistration",
  DeleteCategoryManagement: "CategoryRegistration",
  CategoryManagementFilter: "CategoryRegistration/Filter",
  UpdateCategoryOrderId: "CategoryRegistration/OrderId",
  GetCategorySearchFilter: "CategoryRegistration/Search/Filter",
  GetAllCategory: "CategoryRegistration/All",

  // Treatment management
  GetTreatmentManagementList: `${TreatmentController}/List`,
  GetTreatmentManagementFilter: `${TreatmentController}/Filter`,
  GetSearchTreatmentRegistrationFilter: `${TreatmentController}/Search/Filter`,
  AddTreatment: `${TreatmentController}`,
  UpdateTreatment: `${TreatmentController}`,
  GetTreatmentById: `${TreatmentController}`,
  GetTreatmentRegistartionStoreId: `${TreatmentController}/StoreId`,
  DeleteTreatment: `${TreatmentController}`,
  UpdateStoreTreatmentOrderId: `${TreatmentController}/OrderId`,
  GetTreatmentSummary: `${TreatmentController}/TreatmentList`,

  // Staff management
  GetStaffManagementList: `${StaffController}/List`,
  GetStaffManagementFilter: `${StaffController}/Filter`,
  StaffSearchFilter: `${StaffController}/Search/List`,
  AddStaffManagement: `${StaffController}`,
  UpdateStaffManagement: `${StaffController}`,
  GetStaffManagementById: `${StaffController}`,
  DeleteStaffManagement: `${StaffController}`,
  GetAllStaffByStoreId: `${StaffController}/All/List`,
  GetStaffForShiftList: `${StaffController}/All/StaffForShiftList`,
  CheckIFStaffAlreadyExistInStore: `${StaffController}/CheckIFStaffAlreadyExistInStore`,

  // Store management (additional)
  StoreManagement: `${StoreController}`,
  StorePrefecturePostalCode: `${StoreController}/PostalCode`,
  UpdateStoreCategoryOrderId: `${StoreController}/OrderId`,
  UpdateStorePassword: `Account/Update/Store/Password`,

  // Option management
  OptionManagement: "/OptionManagement",
  GetOptionMenuFilter: "/OptionManagement/Filter",
  GetOptionMenuList: "/OptionManagement/List",
  GetOptionMenuListStore: "/OptionManagement/List",
  AddOptionMenu: "/OptionManagement",
  UpdateOptionMenu: "/OptionManagement",
  GetOptionById: "/OptionManagement",
  DeleteOptionMenu: "/OptionManagement",
  UpdateStoreOptionOrderId: "/OptionManagement/OrderId",

  // Shift management
  ShiftManagement: `${ShiftController}`,
  GetCMSImageByStoreIdImageType: "Cms/Store/Images",
  AddCMSStoreImages: "Cms/Store/Images",

  // Customer management
  AddCustomer: "/CustomerRegistration",
  UpdateCustomer: "/CustomerRegistration",
  DeleteCustomer: "/CustomerRegistration",
  GetCustomerById: "/CustomerRegistration",
  AddCustomerRegister: "/CustomerRegistration/Register",
  ChangeCustomerPassword: "/CustomerRegistration/Update/Customer/Password",
  ChangeCustomerEmail: "/CustomerRegistration/Update/Customer/Email",
  AdvanceSearch: "/CustomerRegistration/Advance/Filter",
  ValidateCustomerRegistration: "/CustomerRegistration/Credentials",

  // Appointment management
  GetTreatmentOptionMenuByCatId: "/AppointmentManagement/All",
  AddAppointment: "/AppointmentManagement",
  AddWalkInCustomerAppointment: "/AppointmentManagement/WalkIn",
  UpdateReservationMemo: "AppointmentManagement/Update/ReservationDetails",
  UpdateReservationCancel: "AppointmentManagement/Update/CancellationType",

  // Customer login and agreement
  CustomerAuthenticate: "CustomerRegistration/Login",
  CustomerFilterList: "CustomerRegistration/FilterList",
  CustomerList: "CustomerRegistration/All",
  AddAgreement: "/Agreement",
  AgreementList: "/Agreement/List",
  AgreementById: "/Agreement/GetAgreementByID",
  UpdateAgreement: "/Agreement/Update",
  DeleteAgreement: "/Agreement",
  GetAllAgreements: "/Agreement/Agreement/All",

  // Reservation and appointment
  GetReservationListFilter: "/AppointmentManagement/Filter",
  UpdateAppointmentStatus: "/AppointmentManagement/Update/AppointmentStatus",
  UpdateBookingType: "AppointmentManagement/Update/BookingType",
  UpdateAppointmentDraggable:
    "AppointmentManagement/Update/AppointmentDateTimeStaff",
  CheckIfStaffAlreadyConsumed:
    "/AppointmentManagement/CheckIfStaffAlreadyConsumed",

  // Staff break management
  UpdateStaffBreak: "StaffBreak",
  GetStaffBreakById: "StaffBreak",
  AddStaffBreak: "StaffBreak",
  DeleteStaffBreak: "StaffBreak",

  // Headquarter management
  GetHeadquarterByBusinessTypeId: "/Headquarter/BusinessTypeId",
  AddHeaquarter: "/Headquarter",
  UpdateHeaquarter: "/Headquarter",
  GetHeadquarterById: "/Headquarter",
  DeleteHeadquarter: "/Headquarter",
  GetHeadquarterTemplatesById: "/Headquarter",
  UpdateHeadquarterIcons: "/Headquarter/Icon",
  UpdateHeadquarterTemplateImages: "/Headquarter/Template",

  // Sales medical record management
  GetSalesMedicalRecordList: "/SalesMedicalRecord/StoreId/CustomerId",
  GetSalesRecordById: "/SalesMedicalRecord",
  AddSalesRecord: "/SalesMedicalRecord",
  UpdateSalesRecordBySMRId: "/SalesMedicalRecord",
  DeleteSalesRecordBySMRId: "/SalesMedicalRecord",
  GetSMRPaymentDetailsBySaleRecordId:
    "/SalesMedicalRecord/PaymentDetails/SaleRecordId",
  AddSMRPaymentDetailsBySaleRecordId: "/SalesMedicalRecord/PaymentDetails",
  UpdateSMRPaymentDetailsBySaleRecordId: "/SalesMedicalRecord/PaymentDetails",

  // Agreement record management
  GetStaffAppointments: "AppointmentManagement/StaffAppointments/Filter",
  GetAppointmentById: "AppointmentManagement",
  AddAgreementRecordBySMRId: "/SalesMedicalRecord/AgreementRecord",
  UpdateAgreementRecordBySMRId: "/SalesMedicalRecord/AgreementRecord",
  DeleteAgreementRecordBySMRId: "/SalesMedicalRecord/AgreementRecord",
  GetAgreementRecordBySMRId: "/SalesMedicalRecord/AgreementRecord",
  GetAgreementRecordHistoryList: "/SalesMedicalRecord/AgreementHistoryList",

  // Navigation password verification
  VerifyNavigationPassword: "/MasterManagement/VerifyNavigationPassword",

  // Medical record management
  AddMedicalRecord: "/SalesMedicalRecord/MedicalRecord",
  GetMedicalRecordImageById: "/SalesMedicalRecord/MedicalImages",
  UpdateMedicalRecordImages: "/SalesMedicalRecord/MedicalImages",
  DeleteMedicalRecordImage: "/SalesMedicalRecord/MedicalImages",
  UpdateMedicalRecordNoteMemo: "/SalesMedicalRecord/MedicalRecord",
  UpdateMedicalRecordImagesOrderId: "/SalesMedicalRecord/MedicalImages/OrderId",
  GetMedicalRecordList: "/SalesMedicalRecord/MedicalRecordList",

  // Reservation settings and staff
  GetReservationSettingMinMax: "MasterManagement/MinTime/MaxTime",
  UpdateReservationPostBreakTime: "AppointmentManagement/Update/PostBreakTime",
  GetStaffManagementByEmail: "/User/Email",
  GetAllStaffReservationDateTime: "Staff/All/List/Reservation",
  GetBlockedAppointment:
    "AppointmentManagement/AppointmentCountByNumberOfAvailability",
  UpdateHeadquarterPassword: "Headquarter/Update/Headquarter/Password",

  // Cancelled reservations
  GetCancelledReservationList: "/AppointmentManagement/List",
  GetHeadquarterCancelationPolicyById: "/Headquarter/CancelationPolicy",

  GetReservationProcessStateById: "AppointmentManagement/Process/",

  InventoryManagement: `${InventoryManagementController}`,
  GetInventoryManagementListByFilter: `${InventoryManagementController}/Filter`,

  GetCMSStaffListByStoreId: "Cms/Staff/All/List",
  GetCMSTreatmentListByStoreId: "Cms/Treatment/Featured/List",
  GetCMSWorkingHoursByStoreId: "Cms/CmsWorkingHourSettings",
  AddCMSWorkingHours: "Cms/CmsWorkingHourSettings",
  UpdateCMSWorkingHours: "Cms/CmsWorkingHourSettings",
  CMSStoreSideCustomerList: "Cms/CustomerSide",

  GetHQEmailSettings: `${EmailManagementController}/HqEmailSettings`,
  AddHQEmailSettings: `${EmailManagementController}/HqEmailSettings`,
  UpdateHQEmailSettings: `${EmailManagementController}/HqEmailSettings`,
  GetStoreEmailSettings: `${EmailManagementController}/StoreEmailSettings`,
  UpdateStoreEmailSettings: `${EmailManagementController}/StoreEmailSettings`,

  GenerateAuthCode: "Account/Generate/Customer/AuthCode",
  AuthenticateAuthCode: "Account/Authenticate/Customer/AuthCode",

  GetDashboardDailyAppointmentDataList:
    "/AppointmentManagement/Store/AppointmentDate",
  GetDashboardDailyProjectedSalesCount:
    "/AppointmentManagement/Store/ProjectedSales",
  GetDailyTotallingSales: `${TotallingManagement}/DailySales`,
  GetCustomerToTreatmentProductDailySales: `${TotallingManagement}/CustomerDailySales`,
  GetCustomerSalesRatio: `${TotallingManagement}/CustomerDailySalesAccToAgeGroup`,
  GetWeeklySalesAndPaymentDetail: `${TotallingManagement}/WeeklySales&PaymentDetail`,
  GetWeeklySalesDetail: `${TotallingManagement}/WeeklySalesDetail`,
  GetStaffSalesDetail: `${TotallingManagement}/StaffSalesDetail`,
  ResetCustomerPassword: "Account/Reset/Customer/Password",
  ResetPasswordAuthLink: "Account/Generate/Customer/AuthLink",
};

export default URLConstants;
